import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { defineMessages, FormattedMessage, useIntl } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuItemGroup } from 'ui-components/components/dropdown-menu-item-group';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { testId } from 'ui-components/services/testid-service';
import { MessageDescriptorPropType } from '../../../../../prop-types/intl';

import { emptyArray } from 'ui-components/default-props/empty';
import style from './style.module.less';

const messages = defineMessages({
  placeholderText: {
    description: 'Returns Page package dropdown placeholder',
    defaultMessage: 'Same as outbound',
    id: 'zNld0h',
  },
  customGroupLabel: {
    description: 'Returns Page package dropdown label for custom package group',
    defaultMessage: 'Your Packaging',
    id: 'eQplxV',
  },
});

const PackageDropdown = ({ groupedPackages = emptyArray, customPackages = emptyArray, onPackageSelected, selectedPackageName = '' }) => {
  const { formatMessage } = useIntl();
  const title = useMemo(() => selectedPackageName || <FormattedMessage {...messages.placeholderText} />, [selectedPackageName]);

  return (
    <DropdownMenu
      {...testId('returns-package-dropdown')}
      className={style['package-type-dropdown']}
      dropdownMenuShouldHaveWidthOfButton
      fullWidth
      variant='form'
    >
      <DropdownMenuToggler className={style['package-type-dropdown-selector']} title={title}>
        {title}
      </DropdownMenuToggler>
      <DropdownMenuItem key='' onClick={() => onPackageSelected('')}>
        {formatMessage(messages.placeholderText)}
      </DropdownMenuItem>
      {customPackages && (
        <DropdownMenuItemGroup key='customGroup' label={formatMessage(messages.customGroupLabel)}>
          {customPackages.map((pkg) => (
            <DropdownMenuItem key={pkg.packageId} onClick={() => onPackageSelected(pkg.packageId)}>
              {pkg.name}
            </DropdownMenuItem>
          ))}
        </DropdownMenuItemGroup>
      )}
      {groupedPackages &&
        groupedPackages.map((group) => (
          <DropdownMenuItemGroup key={group.id} label={formatMessage(group.groupName, group.groupName?.values)}>
            {group?.packages.map((pkg) => (
              <DropdownMenuItem key={pkg.packageId} onClick={() => onPackageSelected(pkg.packageId)}>
                {pkg.name}
              </DropdownMenuItem>
            ))}
          </DropdownMenuItemGroup>
        ))}
    </DropdownMenu>
  );
};

PackageDropdown.propTypes = {
  customPackages: PropTypes.array,
  onPackageSelected: PropTypes.func.isRequired,
  groupedPackages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      groupName: MessageDescriptorPropType,
      packages: PropTypes.array,
    }),
  ),
  selectedPackageName: PropTypes.string,
};

export default PackageDropdown;
